export function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 rounded-lg border border-background-200/50 bg-background-100">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-xl bg-primary-500/10 flex items-center justify-center">
            <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-400"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">吃瓜APP</h2>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed max-w-lg">
              暗网吃瓜移动端专属入口现已上线。随时随地浏览最新黑料爆料、隐秘八卦和真实吃瓜事件，第一时间接收吃瓜速递推送通知。支持 iOS 和 Android，扫码或在应用商店搜索"暗网吃瓜"即可下载。
            </p>
          </div>
          <div className="flex-shrink-0 flex flex-col sm:flex-row gap-3">
            <span className="inline-flex items-center gap-2 px-5 py-3 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap">
              <i className="ri-apple-fill"></i> App Store
            </span>
            <span className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap">
              <i className="ri-google-play-fill"></i> Google Play
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

const comments = [
  { name: '吃瓜不嫌事大', time: '3分钟前', text: '这个料也太劲爆了吧！我直接好家伙，娱乐圈果然比电视剧精彩多了。暗网吃瓜果然名不虚传！', likes: 1283 },
  { name: '匿名瓜友9527', time: '15分钟前', text: '终于有人说这事了，我在微博上看到的时候就觉得不对劲，现在实锤来了。这波我站暗网！', likes: 867 },
  { name: '娱乐圈纪检委', time: '28分钟前', text: '每天必刷暗网吃瓜，比微博热搜真实多了。今天的今日黑料太猛了，朋友圈都在转。', likes: 654 },
  { name: '深夜吃瓜人', time: '42分钟前', text: '凌晨两点还在刷吃瓜速递，我不能一个人睡（不是）。这波新爆料配合之前的线索，基本可以串起来了。', likes: 432 },
  { name: '理性吃瓜群众', time: '1小时前', text: '虽然但是，大家吃瓜也要保持理性啊。暗网吃瓜的信息整理还是很靠谱的，至少比满天飞的截图可信度高。', likes: 298 },
];

export function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">瓜友热评</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">暗网吃瓜社区的精彩评论，看看大家都在聊什么</p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((c, i) => (
            <div key={i} className="p-5 rounded-lg border border-background-200/50 bg-background-50 hover:border-primary-500/20 transition-colors">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-500/20 flex items-center justify-center text-secondary-400 font-medium text-sm">
                  {c.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-700">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">{c.text}</p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> {c.likes}</span>
                <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> 回复</span>
                <span className="flex items-center gap-1"><i className="ri-share-forward-line"></i> 分享</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const updates = [
  { time: '刚刚', title: '某顶流男星深夜发文疑似回应恋情传闻', tag: '独家', tagColor: 'primary' },
  { time: '5分钟前', title: '知名综艺节目录制现场突发状况，导演组紧急叫停', tag: '突发', tagColor: 'accent' },
  { time: '18分钟前', title: '网红主播被曝数据造假，后台截图流出引热议', tag: '实锤', tagColor: 'primary' },
  { time: '32分钟前', title: '某女星与前经纪公司解约内幕曝光，涉及天价违约金', tag: '深扒', tagColor: 'secondary' },
  { time: '45分钟前', title: '娱乐圈大佬聚会照片泄露，座位安排暗藏玄机', tag: '爆料', tagColor: 'accent' },
  { time: '1小时前', title: '热门古装剧男主角选角内幕，原定人选竟是他', tag: '内幕', tagColor: 'primary' },
  { time: '2小时前', title: '某品牌代言人突然换人，背后商业博弈浮出水面', tag: '追踪', tagColor: 'secondary' },
];

export function UpdatesSection() {
  const tagStyles: Record<string, string> = {
    primary: 'bg-primary-500/15 text-primary-400',
    accent: 'bg-accent-500/15 text-accent-400',
    secondary: 'bg-secondary-500/15 text-secondary-400',
  };

  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">吃瓜速递</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">实时追踪全网最新爆料，不错过任何一个瓜</p>
        <div className="mt-10 max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="relative pl-8 pb-8 last:pb-0">
              {i < updates.length - 1 && (
                <div className="absolute left-[11px] top-8 bottom-0 w-px bg-background-200"></div>
              )}
              <div className="absolute left-0 top-1 w-[22px] h-[22px] rounded-full border-2 border-primary-500 bg-background-50 flex items-center justify-center">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${tagStyles[item.tagColor]}`}>
                  {item.tag}
                </span>
                <span className="text-sm text-foreground-700 font-medium">{item.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">关于暗网吃瓜</h2>
          <div className="mt-8 space-y-4 text-sm md:text-base text-foreground-500 leading-relaxed">
            <p>
              暗网吃瓜成立于 2023 年，是国内领先的黑料爆料与隐秘八卦聚合平台。
              我们以"真实、及时、敢说"为核心理念，致力于为每一位吃瓜群众提供最新鲜、最劲爆的娱乐资讯。
            </p>
            <p>
              平台汇聚了来自全网的海量爆料内容，覆盖娱乐圈、网红圈、综艺圈、体育圈等多个领域。
              每日更新 <strong className="text-primary-400">200+</strong> 条吃瓜速递，
              涵盖 <strong className="text-accent-400">50+</strong> 个话题分类。
            </p>
            <p>
              暗网吃瓜坚持匿名投稿机制，保障爆料人信息安全，让每一个真实吃瓜事件都能浮出水面。
              我们的编辑团队 7×24 小时轮值，确保今日黑料和新爆料第一时间呈现在你面前。
              加入爆料交流群，与百万瓜友一起畅聊全网最热话题。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { num: '200+', label: '每日爆料' },
              { num: '50万+', label: '活跃瓜友' },
              { num: '50+', label: '话题领域' },
              { num: '3年', label: '持续运营' },
            ].map((stat, i) => (
              <div key={i} className="p-4 rounded-lg bg-background-50 border border-background-200/50">
                <p className="text-xl md:text-2xl font-heading text-primary-400">{stat.num}</p>
                <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}